import { MatrizEstado } from 'src/utils/enums/MatrizEstado';
import { MatrizFormState } from './types';
import { colorMapping } from 'src/utils/enums/MatrizEstado';
import {
  verificarMatrizF,
  discontinuarMatriz,
  marcarAveriadaMatrizF,
  marcarEnReparacionMatrizF,
} from './apiThunk';
import { RootState } from 'src/app/store';
import { createSlice } from '@reduxjs/toolkit';

const initialState: MatrizFormState = {
  data: null,
  status: null,
  actions: null,
  previousState: undefined,
};

const formSlice = createSlice({
  name: 'matrizForm',
  initialState,
  reducers: {
    resetForm(state) {
      state.data = null;
      state.status = null;
      state.actions = null;
      state.previousState = null;
    },

    setFormStatusBorrador(state) {
      state.status = {
        id: MatrizEstado.Borrador,
        text: MatrizEstado[MatrizEstado.Borrador].toUpperCase(),
        color: colorMapping[MatrizEstado.Borrador],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        verificarMatrizF: {
          visible: true,
          disabled: true,
          tooltip: 'Verificar la matriz',
        },
        discontinuarMatriz: {
          visible: true,
          disabled: true,
          tooltip: 'Discontinuar la matriz',
        },
        marcarAveriadaMatrizF: {
          visible: true,
          disabled: true,
          tooltip: 'Marcar la matriz como averiada',
        },
        marcarEnReparacionMatrizF: {
          visible: true,
          disabled: true,
          tooltip: 'Marcar la matriz en reparación',
        },
      };
    },
    setFormStatusVerificada(state) {
      state.status = {
        id: MatrizEstado.Verificada,
        text: MatrizEstado[MatrizEstado.Verificada].toUpperCase(),
        color: colorMapping[MatrizEstado.Verificada],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        verificarMatrizF: {
          visible: false,
          disabled: false,
          tooltip: 'Verificar la matriz',
        },
        discontinuarMatriz: {
          visible: true,
          disabled: false,
          tooltip: 'Discontinuar la matriz',
        },
        marcarAveriadaMatrizF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar la matriz como averiada',
        },
        marcarEnReparacionMatrizF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar la matriz en reparación',
        },
      };
    },
    setFormStatusNoVerificada(state) {
      state.status = {
        id: MatrizEstado.NoVerificada,
        text: MatrizEstado[MatrizEstado.NoVerificada].toUpperCase(),
        color: colorMapping[MatrizEstado.NoVerificada],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        verificarMatrizF: {
          visible: true,
          disabled: false,
          tooltip: 'Verificar la matriz',
        },
        discontinuarMatriz: {
          visible: true,
          disabled: false,
          tooltip: 'Discontinuar la matriz',
        },
        marcarAveriadaMatrizF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar la matriz como averiada',
        },
        marcarEnReparacionMatrizF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar la matriz en reparación',
        },
      };
    },
    setFormStatusDiscontinuada(state) {
      state.status = {
        id: MatrizEstado.Discontinuada,
        text: MatrizEstado[MatrizEstado.Discontinuada].toUpperCase(),
        color: colorMapping[MatrizEstado.Discontinuada],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        verificarMatrizF: {
          visible: true,
          disabled: false,
          tooltip: 'Verificar la matriz',
        },
        discontinuarMatriz: {
          visible: false,
          disabled: false,
          tooltip: 'Discontinuar la matriz',
        },
        marcarAveriadaMatrizF: {
          visible: true,
          disabled: true,
          tooltip: 'Marcar la matriz como averiada',
        },
        marcarEnReparacionMatrizF: {
          visible: true,
          disabled: true,
          tooltip: 'Marcar la matriz en reparación',
        },
      };
    },
    setFormStatusAveriada(state) {
      state.status = {
        id: MatrizEstado.Averiada,
        text: MatrizEstado[MatrizEstado.Averiada].toUpperCase(),
        color: colorMapping[MatrizEstado.Averiada],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },

        verificarMatrizF: {
          visible: true,
          disabled: false,
          tooltip: 'Verificar la matriz',
        },
        discontinuarMatriz: {
          visible: true,
          disabled: false,
          tooltip: 'Discontinuar la matriz',
        },
        marcarAveriadaMatrizF: {
          visible: false,
          disabled: false,
          tooltip: 'Marcar la matriz como averiada',
        },
        marcarEnReparacionMatrizF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar la matriz en reparación',
        },
      };
    },
    setFormStatusEnReparacion(state) {
      state.status = {
        id: MatrizEstado.EnReparacion,
        text: MatrizEstado[MatrizEstado.EnReparacion].toUpperCase(),
        color: colorMapping[MatrizEstado.EnReparacion],
      };
      state.actions = {
        guardar: {
          visible: true,
          disabled: false,
          tooltip: 'Guardar',
        },
        verificarMatrizF: {
          visible: true,
          disabled: false,
          tooltip: 'Verificar la matriz',
        },
        discontinuarMatriz: {
          visible: true,
          disabled: false,
          tooltip: 'Discontinuar la matriz',
        },
        marcarAveriadaMatrizF: {
          visible: true,
          disabled: false,
          tooltip: 'Marcar la matriz como averiada',
        },
        marcarEnReparacionMatrizF: {
          visible: false,
          disabled: false,
          tooltip: 'Marcar la matriz en reparación',
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(verificarMatrizF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(verificarMatrizF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(discontinuarMatriz.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(discontinuarMatriz.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(marcarAveriadaMatrizF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(marcarAveriadaMatrizF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });

    builder.addCase(marcarEnReparacionMatrizF.fulfilled, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción exitosa.'
      );
    });
    builder.addCase(marcarEnReparacionMatrizF.rejected, (state, action) => {
      console.log(
        'Completar con la lógica correspondiente a la acción fallida.'
      );
    });
  },
});
// Selectors

export const selectFormStatus = (state: RootState) => state.matriz.form.status;

export const selectVerificarMatrizF = (state: RootState) =>
  state.matriz.form.actions?.verificarMatrizF;

export const selectDiscontinuarMatriz = (state: RootState) =>
  state.matriz.form.actions?.discontinuarMatriz;

export const selectMarcarAveriadaMatrizF = (state: RootState) =>
  state.matriz.form.actions?.marcarAveriadaMatrizF;

export const selectMarcarEnReparacionMatrizF = (state: RootState) =>
  state.matriz.form.actions?.marcarEnReparacionMatrizF;

export const selectGuardar = (state: RootState) =>
  state.matriz.form.actions?.guardar;

// Export actions
export const {
  resetForm,
  setFormStatusBorrador,
  setFormStatusVerificada,
  setFormStatusNoVerificada,
  setFormStatusDiscontinuada,
  setFormStatusAveriada,
  setFormStatusEnReparacion,
} = formSlice.actions;

export default formSlice.reducer;
